/**
 * For lightbox and modal launch youtube embed types, play youtube video when modal opens.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.youtubeModal').forEach((element) => {
    element.addEventListener('shown.bs.modal', function (event) {
      event.target.querySelector('lite-youtube').addIframe();
    });
    element.addEventListener('hidden.bs.modal', function (event) {
      event.target.querySelector('lite-youtube').pause();
    });
  });

  document.querySelectorAll('.htmlVideoModal').forEach((element) => {
    element.addEventListener('hidden.bs.modal', function (event) {
      event.target.querySelector('video').pause();
    });
  });
});
